'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _widgetData = require('../widget-data/reducers/widgetData');

var _widgetData2 = _interopRequireDefault(_widgetData);

var _visitorIdentity = require('../visitor-identity/reducers/visitorIdentity');

var _visitorIdentity2 = _interopRequireDefault(_visitorIdentity);

var _widgetUi = require('../widget-ui/reducers/widgetUi');

var _widgetUi2 = _interopRequireDefault(_widgetUi);

var _emailCaptureReducer = require('../email-capture/emailCaptureReducer');

var _emailCaptureReducer2 = _interopRequireDefault(_emailCaptureReducer);

var _availabilityMessageTimeouts = require('../availability/reducers/availabilityMessageTimeouts');

var _availabilityMessageTimeouts2 = _interopRequireDefault(_availabilityMessageTimeouts);

var _clientData = require('../client-data/reducers/clientData');

var _clientData2 = _interopRequireDefault(_clientData);

var _responders = require('../responders/reducers/responders');

var _responders2 = _interopRequireDefault(_responders);

var _visitorThreadHistories = require('../thread-histories/reducers/visitorThreadHistories');

var _visitorThreadHistories2 = _interopRequireDefault(_visitorThreadHistories);

var _stubbedThreadHistory = require('../stubbed-thread-history/reducers/stubbedThreadHistory');

var _stubbedThreadHistory2 = _interopRequireDefault(_stubbedThreadHistory);

var _tracker = require('../usage-tracking/reducers/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

var _agentTypingStatesReducer = require('../typing-indicators/reducers/agentTypingStatesReducer');

var _agentTypingStatesReducer2 = _interopRequireDefault(_agentTypingStatesReducer);

var _botTypingStatesReducer = require('../typing-indicators/reducers/botTypingStatesReducer');

var _botTypingStatesReducer2 = _interopRequireDefault(_botTypingStatesReducer);

var _fileUploads = require('../file-uploads/reducers/fileUploads');

var _fileUploads2 = _interopRequireDefault(_fileUploads);

var _fileUploadsErrors = require('../file-uploads/reducers/fileUploadsErrors');

var _fileUploadsErrors2 = _interopRequireDefault(_fileUploadsErrors);

var _resolvedAttachments = require('../resolved-attachments/reducers/resolvedAttachments');

var _resolvedAttachments2 = _interopRequireDefault(_resolvedAttachments);

var _createThreadStatus = require('../threads/reducers/createThreadStatus');

var _createThreadStatus2 = _interopRequireDefault(_createThreadStatus);

var _pubSubClient = require('conversations-internal-pub-sub/redux/reducers/pubSubClient');

var _iframeUuid = require('../iframeUuid/reducers/iframeUuid');

var _iframeUuid2 = _interopRequireDefault(_iframeUuid);

var _gdpr = require('../gdpr/reducers/gdpr');

var _gdpr2 = _interopRequireDefault(_gdpr);

var _currentView = require('../current-view/reducers/currentView');

var _currentView2 = _interopRequireDefault(_currentView);

var _initialMessageBubbleVisible = require('../initial-message-bubble/reducers/initialMessageBubbleVisible');

var _initialMessageBubbleVisible2 = _interopRequireDefault(_initialMessageBubbleVisible);

var _timeOnPageTrigger = require('../time-on-page-trigger/reducers/timeOnPageTrigger');

var _timeOnPageTrigger2 = _interopRequireDefault(_timeOnPageTrigger);

var _threads = require('../threads/reducers/threads');

var _threads2 = _interopRequireDefault(_threads);

var _selectedThreadId = require('../selected-thread/reducers/selectedThreadId');

var _selectedThreadId2 = _interopRequireDefault(_selectedThreadId);

var _unpublishedMessages = require('../pubsub/reducers/unpublishedMessages');

var _unpublishedMessages2 = _interopRequireDefault(_unpublishedMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  agentTypingStates: _agentTypingStatesReducer2.default,
  availabilityMessageTimeouts: _availabilityMessageTimeouts2.default,
  botTypingStates: _botTypingStatesReducer2.default,
  clientData: _clientData2.default,
  createThreadStatus: _createThreadStatus2.default,
  currentView: _currentView2.default,
  emailCapture: _emailCaptureReducer2.default,
  fileUploads: _fileUploads2.default,
  fileUploadsErrors: _fileUploadsErrors2.default,
  gdpr: _gdpr2.default,
  iframeUuid: _iframeUuid2.default,
  initialMessageBubbleVisible: _initialMessageBubbleVisible2.default,
  pubSubClient: _pubSubClient.pubSubClient,
  resolvedAttachments: _resolvedAttachments2.default,
  responders: _responders2.default,
  selectedThreadId: _selectedThreadId2.default,
  stubbedThreadHistory: _stubbedThreadHistory2.default,
  threadHistories: _visitorThreadHistories2.default,
  threads: _threads2.default,
  timeOnPageTrigger: _timeOnPageTrigger2.default,
  tracker: _tracker2.default,
  unpublishedMessages: _unpublishedMessages2.default,
  visitorIdentity: _visitorIdentity2.default,
  widgetData: _widgetData2.default,
  widgetUi: _widgetUi2.default
});
module.exports = exports['default'];